import {
    REGISTER_REQUESTING,
  } from './constants'
  
// In order to perform an action of type REGISTER_REQUESTING
// we need an email and password
export const registerRequest = function registerRequest (postData) {
  return {
    type: REGISTER_REQUESTING,
    payload: postData
  }
}

export default registerRequest


// WEBPACK FOOTER //
// ./src/views/Pages/Register/actions.js